import { notification, Button } from 'antd'
import './notification.scss'

export const Notify = (message: string) => {
  notification.open({
    message: message,
    duration: 3,
    placement: 'topRight',
    className: 'responsiveMobileNotify',
    top: 87,
  })
}
